export default __webpack_public_path__ + "static/media/SIMTalent1.e7f80523.png";